import BaseStore from './BaseStore'

export class UserStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'users'
  }
}

export default new UserStore()


// WEBPACK FOOTER //
// ./src/stores/UserStore.js